import { Link } from 'react-router-dom';
import Card from '../components/Card';
import { ReactComponent as Close } from '../svg/sharp-x.svg';

export default function Fail() {
  return (
    <Card className='card-fail text-white'>
      <Close className='mx-auto' width='64' height='64' />
      <h3 className='mt-25 text-2xl'>
        ARTIVIST CHIP
        <br /> not found
      </h3>
      <div className='text-sm pt-32 mb-20'>
        <p>Please reconnect your ARITIVIST CHIP.</p>
        <p>If the issue continues,</p>
        <p>Reach out to Customer Service for help.</p>
      </div>
      <div className='button-wrap'>
        <Link
          to='https://artivistglobal.com/contact'
          target='_blank'
          className='text-white uppercase text-xs'
        >
          contact
        </Link>
        <Link to='/' className='text-white uppercase text-xs'>
          back
        </Link>
      </div>
    </Card>
  );
}
